var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35px",
    height: "35px",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4420 4599 c-19 -11 -328 -314 -687 -672 l-652 -651 -3 390 -3 390 -27 41 c-63 96 -208 96 -267 -1 -21 -34 -21 -37 -19 -658 3 -605 4 -624 23 -650 11 -15 38 -37 61 -48 39 -19 59 -20 638 -20 574 0 598 1 635 20 113 57 113 223 0 280 -36 19 -60 20 -426 20 l-388 0 667 668 c704 705 698 699 684 775 -21 113 -141 172 -236 116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995 2341 c-43 -26 -61 -50 -75 -96 -24 -83 28 -170 117 -194 23 -7 181 -11 408 -11 l370 0 -662 -662 c-718 -719 -686 -682 -668 -775 9 -49 69 -109 118 -118 93 -18 56 -50 775 668 l662 662 0 -368 c0 -238 4 -384 11 -412 15 -58 71 -110 128 -120 53 -9 126 25 158 74 l23 34 0 616 c0 597 -1 617 -20 649 -11 18 -34 41 -52 52 -32 19 -52 20 -648 20 -581 0 -617 -1 -645 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenSplit);
export default __webpack_public_path__ + "static/media/screen-split.87e4b651a1531659a414f4d7814480b3.svg";
export { ForwardRef as ReactComponent };